import { render, staticRenderFns } from "./BatchDistribution.vue?vue&type=template&id=b6c74aea&scoped=true&"
import script from "./BatchDistribution.vue?vue&type=script&lang=js&"
export * from "./BatchDistribution.vue?vue&type=script&lang=js&"
import style0 from "./BatchDistribution.vue?vue&type=style&index=0&id=b6c74aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c74aea",
  null
  
)

export default component.exports